export default function Hero() {
  const scrollToInvestimento = () => {
    const element = document.getElementById('investimento');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/5586988088824?text=Olá! Tenho interesse no Freedom Experience', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-12 md:py-20">
      {/* Grid Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full" style={{
          backgroundImage: 'linear-gradient(rgba(0,212,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.3) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 md:w-96 h-64 md:h-96 bg-neon-blue/20 rounded-full blur-[80px] md:blur-[120px] animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 md:w-96 h-64 md:h-96 bg-neon-purple/20 rounded-full blur-[80px] md:blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center max-w-7xl mx-auto">
          {/* Content */}
          <div className="space-y-6 md:space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-blue/10 border border-neon-blue/30 backdrop-blur-sm animate-fade-in">
              <i className="ri-sparkling-2-fill text-neon-blue text-sm md:text-base"></i>
              <span className="text-neon-blue text-xs md:text-sm font-semibold tracking-wide">CURSO DE FÉRIAS DISRUPTIVO</span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-white leading-tight animate-slide-up">
              <span className="block bg-gradient-to-r from-neon-blue via-neon-purple to-neon-pink bg-clip-text text-transparent">
                Freedom Experience
              </span>
            </h1>

            {/* Subtitle */}
            <p className="text-xl sm:text-2xl md:text-3xl text-white font-bold animate-slide-up" style={{ animationDelay: '0.1s' }}>
              Prepare Seu Filho Para o Futuro
            </p>

            {/* Description */}
            <p className="text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
              Um curso presencial inédito em Teresina que ensina o que a escola tradicional nunca vai ensinar: as principais habilidades do futuro. <strong className="text-white">Inteligência Artificial, Bitcoin, Empreendedorismo, Vendas, Oratória, Pensamento Estratégico, Propósito de Vida, Como Ganhar Dinheiro</strong> e muito mais. Exclusivamente para crianças e adolescentes de <strong className="text-neon-blue">8 a 17 anos</strong>.
            </p>

            {/* Key Points */}
            <div className="flex flex-wrap items-center gap-3 md:gap-6 text-sm md:text-base text-gray-300 animate-slide-up" style={{ animationDelay: '0.3s' }}>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-fill text-neon-blue text-lg md:text-xl"></i>
                <span>Presencial em Teresina</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-fill text-neon-purple text-lg md:text-xl"></i>
                <span>3 Semanas Intensivas</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-start gap-3 md:gap-4 pt-4 md:pt-6 animate-slide-up" style={{ animationDelay: '0.4s' }}>
              <button 
                onClick={scrollToInvestimento}
                className="group relative px-6 md:px-8 py-3.5 md:py-4 bg-gradient-to-r from-neon-blue to-neon-purple rounded-xl font-bold text-base md:text-lg text-white overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(0,212,255,0.8)] whitespace-nowrap cursor-pointer"
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  <i className="ri-rocket-2-fill text-lg md:text-xl"></i>
                  Garantir Minha Vaga
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-neon-purple to-neon-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>

              <button 
                onClick={handleWhatsApp}
                className="px-6 md:px-8 py-3.5 md:py-4 bg-dark-800/80 backdrop-blur-sm border-2 border-neon-blue/30 rounded-xl font-bold text-base md:text-lg text-white hover:bg-dark-700 hover:border-neon-blue transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-whatsapp-fill text-lg md:text-xl text-neon-blue"></i>
                Falar no WhatsApp
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-4 md:gap-6 pt-6 md:pt-8 animate-fade-in" style={{ animationDelay: '0.5s' }}>
              <div className="text-center space-y-1 md:space-y-2">
                <p className="text-2xl sm:text-3xl md:text-4xl font-black text-neon-blue">+500</p>
                <p className="text-xs md:text-sm text-gray-400">Alunos Transformados</p>
              </div>
              <div className="text-center space-y-1 md:space-y-2">
                <p className="text-2xl sm:text-3xl md:text-4xl font-black text-neon-purple">4.9★</p>
                <p className="text-xs md:text-sm text-gray-400">Avaliação Média</p>
              </div>
              <div className="text-center space-y-1 md:space-y-2">
                <p className="text-2xl sm:text-3xl md:text-4xl font-black text-neon-pink">98%</p>
                <p className="text-xs md:text-sm text-gray-400">Pais Satisfeitos</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative block">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden border border-neon-blue/30 shadow-[0_0_60px_rgba(0,212,255,0.4)]">
              <img 
                src="https://static.readdy.ai/image/9dca404c9b2236a1a1235bd6ca7530fb/d16070836e1b65da174990ceff918183.jpeg"
                alt="Jovem preparado para o futuro"
                className="w-full h-auto object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-neon-blue/20 via-transparent to-neon-purple/20"></div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-6 -right-6 bg-dark-800/90 backdrop-blur-xl border border-neon-blue/40 rounded-2xl p-4 shadow-[0_0_30px_rgba(0,212,255,0.4)] animate-float overflow-hidden">
              {/* Grid Background */}
              <div className="absolute inset-0 opacity-10">
                <div className="w-full h-full" style={{
                  backgroundImage: 'linear-gradient(rgba(0,212,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.3) 1px, transparent 1px)',
                  backgroundSize: '12px 12px'
                }}></div>
              </div>
              <div className="flex items-center gap-3 relative z-10">
                <div className="w-12 h-12 bg-gradient-to-br from-neon-blue to-neon-purple rounded-xl flex items-center justify-center">
                  <i className="ri-brain-fill text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Inteligência</p>
                  <p className="text-neon-blue font-semibold text-xs">Artificial</p>
                </div>
              </div>
            </div>

            <div className="absolute top-1/3 -left-6 bg-dark-800/90 backdrop-blur-xl border border-neon-purple/40 rounded-2xl p-4 shadow-[0_0_30px_rgba(168,85,247,0.4)] animate-float" style={{ animationDelay: '1s' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-neon-purple to-neon-pink rounded-xl flex items-center justify-center">
                  <i className="ri-bit-coin-fill text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Bitcoin</p>
                  <p className="text-neon-purple font-semibold text-xs">Cripto</p>
                </div>
              </div>
            </div>

            <div className="absolute bottom-6 -right-6 bg-dark-800/90 backdrop-blur-xl border border-neon-pink/40 rounded-2xl p-4 shadow-[0_0_30px_rgba(236,72,153,0.4)] animate-float" style={{ animationDelay: '2s' }}>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-neon-pink to-neon-blue rounded-xl flex items-center justify-center">
                  <i className="ri-lightbulb-flash-fill text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm">Empreendedorismo</p>
                  <p className="text-neon-pink font-semibold text-xs">Criatividade</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl md:text-3xl text-neon-blue"></i>
      </div>
    </section>
  );
}
